import React from 'react'
import {Box, Grid, Typography, useMediaQuery} from '@mui/material';
import p1 from '../../images/mern-ecommerce.png';
import p2 from '../../images/mern-hotel-booking.png';
import p3 from '../../images/quiz-app.png';
import Project from './Project';

function Portfolio() {
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <Box component={"div"} id='portfolio' py={5}>
        <Typography variant='h3' sx={{ fontWeight: "700"}} textAlign="center" width={350} borderBottom="1px solid" borderColor={"primary"} color="primary" m="auto" mb={5}>Portfolio</Typography>
        <Grid container px={isSmallScreen ? 2 : 10} flexWrap='wrap' alignItems="stretch" justifyContent={isSmallScreen ? "center" : "flex-start"} gap={4}>
            <Project 
                img={p1}
                title="Mern Ecommerece" 
                desc="Dynamic MERN e-commerce site featuring user authentication, smart product filtering, secure payments, and an intuitive admin dashboard. Seamless shopping experience with responsive design and performance optimization."
                live="https://mern-ecommerce-567.netlify.app/"
                github="https://github.com/sidul567/mern-ecommerce"
                delay={0}
                technology="React.js, Redux Node.js, Express.js, MongoDB, JWT(User Authentication), RazorPay(Payment Gateway)."
            />
            <Project 
                img={p2} 
                title="Mern Hotel Booking" 
                desc="Mern Hotel-Booking offers users to advanced search(basedon price, people, date) and easy booking hotel. It featuring user authentication, secure payments also. The admin dashboard provided real-time insights for efficient monitoring. The admin can scan the QR code of the ticket using a webcam."
                live="https://mern-hotel-booking-567.netlify.app/"
                github="https://github.com/sidul567/mern-hotel-booking"
                delay={0.3}
                technology="React.js, Context API, Node.js, Express.js, MongoDB, JWT(User Authentication), RazorPay(Payment Gateway)."
            />
            <Project 
                img={p3} 
                title="React Quiz App" 
                desc="I've crafted the 'React Quiz App' enabling users to access educational YouTube videos. Users engage in interactive quizzes with multi-choice questions, receiving instant feedback post-submission. The app emphasizes security, mandating user authentication for quiz participation. Admin capabilities facilitate effortless quiz management, including creation, deletion, and updates."
                live="https://react-quiz-app-567.web.app/"
                github="https://github.com/sidul567/react-quiz-app"
                delay={0.6}
                technology="React.js, Firebase, Context API"
            />
            <Project 
                img={p2} 
                title="Mern Hotel Booking" 
                desc="Mern Hotel-Booking offers users to advanced search(basedon price, people, date) and easy booking hotel. It featuring user authentication, secure payments also. The admin dashboard provided real-time insights for efficient monitoring. The admin can scan the QR code of the ticket using a webcam."
                live="https://mern-hotel-booking-567.netlify.app/"
                github="https://github.com/sidul567/mern-hotel-booking"
                delay={0.9}
            />
        </Grid>
    </Box>
  )
}

export default Portfolio